import React from 'react';

const SvgHome = (props) => (
  <svg width={25} height={25} {...props}>
    <defs>
      <path
        id="home_svg__a"
        d="M22 20.026c0 .205-.08.402-.223.548a.763.763 0 0 1-.544.23.773.773 0 0 1-.768-.778v-9.977l-8.23-7.964-8.267 7.951v12.538h4.558v-8.481c0-.429.343-.778.768-.778h5.939c.425 0 .768.35.768.778v8.481h3.717c.426 0 .77.35.77.78 0 .424-.334.77-.752.78H3.2a.763.763 0 0 1-.545-.229.783.783 0 0 1-.223-.548V11.513l-.913.878a.768.768 0 0 1-1.247-.277.785.785 0 0 1 .185-.85l2.178-2.1a.624.624 0 0 1 .062-.06L11.68.445a.76.76 0 0 1 1.063 0l11.207 10.84c.241.3.229.734-.03 1.019-.26.287-.69.335-1.035.086l-.884-.856v8.49zm-2.264 3.609v.5h-.018v-.5h.018zm-5.27-8.764h-4.404v7.703h4.403v-7.703z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="home_svg__b" fill="#fff">
        <use xlinkHref="#home_svg__a" />
      </mask>
      <use fill="currentColor" fillRule="nonzero" xlinkHref="#home_svg__a" />
      <g fill="currentColor" mask="url(#home_svg__b)">
        <path d="M0 0h24v24H0z" />
      </g>
    </g>
  </svg>
);

export default SvgHome;
